import axios from 'axios';
import NProgress from 'nprogress';
import router from '@/system/engine/router';
import 'nprogress/nprogress.css';
import {getTokenByName} from '@/system/store/cookie';

NProgress.configure({ showSpinner: false });

const service = axios.create({
	baseURL: process.env.BASE_API,
	timeout: 60000,
	withCredentials: true
});

service.interceptors.request.use(
	config =>{
		NProgress.start();
		
		const token = getTokenByName('auth_sign_token');
		if(token){
			config.headers = {
				"X-Auth": "Bearer "+token
			}
		}
		
		return config;
	}, error =>{
		console.log(error);
		Promise.reject(error);
	}
);

service.interceptors.response.use(
	response =>{
		NProgress.done();
		
		const data = response.data;
		
		if(data.maintenance){
			router.push('/maintenance');
		}else{
			return data;
		}
	}, error =>{
		console.log(error);
		router.push('/nofound');
	}
	
);

export default service;